/** In-app User Guide (`/w/:ws/guide`): URL keys, search tuning and content rules. */
export const GUIDE = {
  /** Query-string key holding the search text of the guide home, so a search can be shared. */
  queryParam: "q",
  /** Query-string key holding the selected module of the guide home. */
  moduleParam: "module",
  /** Wait after the last keystroke before the search runs and the URL is updated. */
  searchDebounceMs: 250,
  /** Longest search text accepted. */
  maxQueryLength: 80,
  /** The command palette starts fetching the guide content this long after the console mounts. */
  preloadDelayMs: 2_000,
  /** Screenshots are served from `apps/console/public/guide/<topic-id>/<nn>.jpg`. */
  shotPathPrefix: "/guide/",
  /** Topic ids double as URL segments and screenshot folder names. */
  topicIdPattern: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
  /** Words the search ignores, so "how do I add a document" finds "Add a document" (English and Filipino). */
  stopWords: [
    "a", "an", "and", "are", "can", "do", "does", "for", "how", "i", "in", "is", "it", "me", "my", "of", "on", "or", "the", "to", "we", "what", "where", "when", "with", "you", "your",
    "ako", "ang", "ba", "ko", "mo", "ng", "paano", "po", "sa",
  ],
} as const;
